import _ from 'lodash'
import { getMetaEnvString } from './meta'

const appDomain = getMetaEnvString('APP_DOMAIN')
const isProduction = appDomain === 'flightvoucher.com' || appDomain === 'vp-lhg.com'
const isStaging = appDomain === 'vp-lhg-tst.com'

const environmentName = _.get([
  { key: isProduction, value: 'production' },
  { key: isStaging, value: 'staging' },
].find((item) => item.key), 'value', 'unknown')

export { isProduction, isStaging, environmentName }
